module.exports = __webpack_public_path__ + "static/img/Select.465b6393.svg";